// This is an auto-generated file. Do not edit it directly — your changes will be overwritten the next time the model configs are generated.

 import type { Role } from '@pigello/pigello-matrix';


import { useGetInstance, useGetList } from '@/requests/hooks';

import type {
  useGetGenericInstanceProps,
  useGetGenericListProps,
} from '@/requests/types';


export const useGetRole = (
  options: useGetGenericInstanceProps<Role>
) => {
  return useGetInstance<Role>({
    ...options,
    modelName: 'role'
  });
};

export const useGetRoleList = (
  options: useGetGenericListProps<Role>
) => {
  return useGetList<Role>({
    ...options,
    modelName: 'role'
  });
};
